<div class="waiting-popup-container">
    <div class="waiting-popup-container-inside">
        <div class="waiting-popup-text">
            {{waitingMessage}}
        </div>
        
        <mat-progress-bar class="progress-bar-style" mode="indeterminate"></mat-progress-bar>        
    </div>
</div>